import { useEffect } from 'react';
import { useEndpoint } from '../../../../api/hooks/endpoint/useEndpoint';
import { PolygonZoneManager } from './PolygonZoneManager';

import './delivery-zones-panel.scss';

export const DeliveryZonesPanel = () => {
  const polygonsQuery = useEndpoint('/delivery/zones/polygons', 'delivery-polygons');

  useEffect(() => {
    polygonsQuery.refetch();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps
  const polygons = polygonsQuery.data ?? [];

  const handleAddPolygon = (polygon, onSuccess) => {
    polygonsQuery.create({ data: polygon, onSuccess: () => onSuccess?.() });
  };

  const handleRemovePolygon = (id) => {
    polygonsQuery.remove({ data: id });
  };

  return (
    <div className="delivery-zones-panel">
      <div className="delivery-zones-panel__section">
        <div className="delivery-zones-panel__section-header">
          <p className="delivery-zones-panel__section-desc">
            Search for a suburb, city or area. Select a boundary level, mark it as include or
            exclude, and save. Exclude zones always take priority over include zones.
          </p>
        </div>
        <PolygonZoneManager
          zones={polygons}
          onAdd={handleAddPolygon}
          onRemove={handleRemovePolygon}
          saving={polygonsQuery.mutating}
        />
      </div>

      {polygons.length === 0 && (
        <p className="delivery-zones-panel__no-restriction">
          ⚠️ No zones configured. Delivery is currently unrestricted.
        </p>
      )}
    </div>
  );
};
